import { render } from "./Dot.vue?vue&type=template&id=2e0757ac&scoped=true&ts=true"
import script from "./Dot.vue?vue&type=script&lang=ts"
export * from "./Dot.vue?vue&type=script&lang=ts"

import "./Dot.vue?vue&type=style&index=0&id=2e0757ac&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e0757ac"]])

export default __exports__